import styled from 'styled-components';
import { getScrollBarStyles } from '../../../../config/styles';
import { theme } from '../../../../styles/theme';

export const PreviewTableFormWrapper = styled.div`
  border: solid 1px ${theme.colors.border};
`;

// Loader heights should also cover the buttons header to avoid having
// items below to jump up/down while loading
const PREVIEW_TABLE_HEADER_HEIGHT = 74;
const PREVIEW_TABLE_SMALL_HEIGHT = 192; // 6 rows
const PREVIEW_TABLE_NORMAL_HEIGHT = 384; // 12 rows

export const LoaderWrapper = styled.div<{ $small: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: ${({ $small }) =>
    PREVIEW_TABLE_HEADER_HEIGHT +
    ($small ? PREVIEW_TABLE_SMALL_HEIGHT : PREVIEW_TABLE_NORMAL_HEIGHT)}px;
`;

export const PreviewTableRowsWrapper = styled.div<{ $small: boolean }>`
  overflow: auto;
  white-space: nowrap;
  height: ${({ $small }) =>
    $small ? PREVIEW_TABLE_SMALL_HEIGHT : PREVIEW_TABLE_NORMAL_HEIGHT}px;
  ${getScrollBarStyles(4)}
`;

export const CellContentWrapper = styled.div<{ $isResultColumn?: boolean }>`
  padding-left: 4px;
  padding-right: 4px;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: ${({ $isResultColumn }) => ($isResultColumn ? 600 : 500)};
`;
